import { useState } from "react";
import { login } from "./api";

export default function PasswordGate({ onAuthed }) {
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(pw);
      onAuthed();
    } catch (ex) {
      setErr(ex.message === "Incorrect password" ? "Incorrect password." : "Authentication failed.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="tbg-vw-modal" data-testid="viewer-auth-modal">
      <form className="tbg-vw-modal-card" onSubmit={submit}>
        <div className="h-sub">TBG · Restricted Access</div>
        <h2>Viewer</h2>
        <div style={{ height: 18 }} />
        <input
          autoFocus
          type="password"
          value={pw}
          onChange={(e) => setPw(e.target.value)}
          placeholder="Shared access password"
          className="tbg-vw-input"
          data-testid="viewer-auth-password"
        />
        {err && <div className="tbg-vw-modal-err" data-testid="viewer-auth-error">{err}</div>}
        <div className="tbg-vw-modal-foot">
          <button
            type="submit"
            className="tbg-vw-btn primary"
            disabled={busy || !pw}
            data-testid="viewer-auth-submit"
          >
            {busy ? "Verifying…" : "Enter Viewer"}
          </button>
        </div>
      </form>
    </div>
  );
}
